import { render, staticRenderFns } from "./GenderFilter.vue?vue&type=template&id=0904c8fc"
import script from "./GenderFilter.vue?vue&type=script&lang=js"
export * from "./GenderFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports